
import { Component, Vue, Prop, PropSync } from "vue-property-decorator";

// {\"mode\":1,\"result\":1,\"salesOrganisation\":\"3088\",\"salesOrganisationDE\":\"3088\",\"salesOrganisationAT\":\"3153\",\"credentials\":\"customer_search_shop\"}
type SettingList = {
	mode: number,
	result: number,
	salesOrganisation: string,
	salesOrganisationDE: string,
	salesOrganisationAT: string,
	credentials: string,
}

@Component
export default class SettingCustomerSearch extends Vue
{
	@Prop(String) readonly settingsJsonString: string | undefined;

	settings: SettingList | null = null;

	parse()
	{
		console.log("SettingDebug:jsonstring", this.settingsJsonString);
		if(!this.settingsJsonString)
		{
			return;
		}

		const parsed: SettingList = JSON.parse(this.settingsJsonString);
		console.log("SettingDebug:jsonstring:parsed", parsed);

		this.settings = parsed;
	}

	changed()
	{
		this.$emit("updated", "customerSearch", JSON.stringify(this.settings));
	}

	// updated()
	// {
	// 	this.parse();
	// }

	mounted()
	{
		this.parse();
	}
}
